// @ts-nocheck
import IInitializableModule from '@episerver/spa-core/Core/IInitializableModule';
import IServiceContainer from '@episerver/spa-core/Core/IServiceContainer';
import IEpiserverContext from '@episerver/spa-core/Core/IEpiserverContext';
import IStateReducerInfo from '@episerver/spa-core/Core/IStateReducerInfo';
import authenticationProvider from './authenticationProvider';
import authenticationReducer, {reAuthenticateThunk} from './authenticationSlice';
import Config from '../../Config';
import ReactGa from 'react-ga';

export default class AuthenticationInitializableModule implements IInitializableModule {
  protected name: string = 'Authentication module';

  public GetName(): string {
    return this.name;
  }

  public ConfigureContainer(container: IServiceContainer): void {
    container.addService('AuthenticationProvider', authenticationProvider);
  }

  public StartModule(context: IEpiserverContext): void {
    if (context.isDebugActive()) {
      console.debug(`Starting ${this.GetName()}`);
    }

    context.dispatch(reAuthenticateThunk(context.getCurrentPath()));
  }

  public GetStateReducer(): IStateReducerInfo<any> | null {
    return {
      stateKey: 'authentication',
      reducer: authenticationReducer,
    };
  }
}
